import React from 'react';
import { ropeKnot } from '../../../components/shared/vector-images';
import Text from '../../../components/shared/_deprecated/elements/Text/Text';
import {
  onInitializeStandardMarker,
  onToggleStandardMarker,
} from '../_helpers';

const layer = {
  displayName: 'Chandlery',
  synonyms: 'shop store',
  group: 'standardMarker',
  typeUrl: 'chandlery',
  icon: {
    baseShape: ropeKnot,
    iconColor: '#fff',
    markerColor: '#56AC5C',
  },
  shownByDefault: true,
  relativeDepth: 0,
  menuOptions: {
    visible: true,
    owningMenu: 'marine-facilities',
    order: 5,
  },
  standardMarkerOptions: {
    markerType: 'chandleryMarker',
    allowCreation: true,
    allowEditing: false,
    allowComments: true,
    viewOptions: {
      typeTitle: 'Chandlery',
      itemTitleFunction: (item) => (item && item.title) || 'Chandlery',
    },
    creationOptions: {
      menuText: 'Chandlery',
      newTitle: 'Chandlery',
      titlePlaceholder: 'Name of marker',
      markerTypeDescription: [
        <Text key="description-text-1" size="-1" paragraph>
          This marker indicates a chandlery location.
        </Text>,
        <Text key="description-text-2" size="-1" paragraph>
          Information provided should be factual. Once you submit this marker,
          you can add your personal experiences or questions as a comment
          underneath.
        </Text>,
      ],
      checkBoxItems: [],
    },
    editingOptions: {},
  },
  popOverConfiguration: (marker) => ({
    markerType: layer.standardMarkerOptions.markerType,
    id: marker.id,
    displayChat: true,
    displayUpVotes: true,
    title: 'Chandlery',
    description: marker.title,
  }),
};

layer.onInitialize = onInitializeStandardMarker(layer);
layer.onToggle = onToggleStandardMarker(layer);

export default layer;
